import styled from "styled-components"

import View from "./view"

export default styled(View).attrs({
  as: "img",
})``
